import { setTerms } from '@/packages/JsonQuery/helpers';

export const setBuildingElevatorType = setTerms('building_lift_types_type');
